import PageLayout from 'pages/ViewSubmission/PageLayout';
import PageProvider from 'pages/ViewSubmission/PageProvider';

const ViewSubmissionPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default ViewSubmissionPage;
